import dev_vars from './.env-dev';
import staging_vars from './.env-staging';
import prod_vars from './.env-prod';

let vars = {};

if (process.env.NODE_ENV === 'development') {
  vars = dev_vars;
} else if (process.env.NODE_ENV === 'staging') {
  vars = staging_vars;
} else if (process.env.NODE_ENV === 'production') {
  vars = prod_vars;
}

export default vars;
